import { render, staticRenderFns } from "./combination_record.vue?vue&type=template&id=a2aec27a&scoped=true&"
import script from "./combination_record.vue?vue&type=script&lang=js&"
export * from "./combination_record.vue?vue&type=script&lang=js&"
import style0 from "./combination_record.vue?vue&type=style&index=0&id=a2aec27a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2aec27a",
  null
  
)

export default component.exports